import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Translate, I18n } from "react-redux-i18n";
import { FaArrowLeft } from "react-icons/fa";

import "./styles/AdNew.css";
import "./styles/PanelEditAd.css";

import PlanAdCallAction from "../components/PlanAdCallAction";
import AdTip from "../components/AdTip";
import AdForm from "../components/AdForm";

const KIND_LABEL_KEYS = {
  sale: "sale",
  rent: "rent",
  exchange: "exchange",
  donation: "donation",
  auction: "auction",
};

class AdNew extends React.Component {
  render() {
    const kind = this.props.match.params.kindCommerce_id;
    const kindLabelKey = KIND_LABEL_KEYS[kind] || "sale";

    return (
      <div className="adnew-page">
        <div className="adnew-page__inner">
          <header className="adnew-page__header">
            <Link to="/panel/ads" className="adnew-page__back" aria-label="Back">
              <FaArrowLeft />
            </Link>
            <div className="adnew-page__heading">
              <h1 className="adnew-page__title">
                <Translate value="ad_new" />
              </h1>
              <p className="adnew-page__subtitle">{I18n.t(kindLabelKey)}</p>
            </div>
          </header>

          <div className="adnew-page__layout">
            <aside className="adnew-page__sidebar">
              <AdTip />
              <PlanAdCallAction />
            </aside>

            <main className="adnew-page__main">
              <section className="panel-edit-ad-card adnew-page__form-card">
                <h2 className="panel-edit-ad-card__title">
                  <Translate value="ad_new_title" />
                </h2>
                <AdForm />
              </section>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AdNew);
